export default __webpack_public_path__ + "static/media/gold_ring.7f2c7dd0.png";